import type { Partner } from "@expert/shared-types";

export function shouldDisableSalesForClient(partner: Partner, client?: string): boolean {
    switch (partner) {
        case "verizon":
            return client === "VZN_LOYALTY";
        default:
            return false;
    }
}
